# Given an email address, this directive will add an ``<img>`` with either the
# user's Gravatar avatar, or a default placeholder image.
#
# Usage:
#   <user-avatar email="foo@bar.com"></user-avatar>
#
angular.module("rjmNg.directives").directive "userAvatar", [
  "$httpParamSerializerJQLike"
  "md5"
  (
    $httpParamSerializerJQLike
    md5
  ) ->
    bindToController: true
    controllerAs: "view"
    restrict: "E"
    scope:
      email: "="
      size: "="
      className: "="
    template: "<img class='rj-user-icon {{view.className}}' src='{{view.src}}' alt='Profile Picture'>"
    controller: [
      () ->


        view = @
        view.DEFAULT_SRC = "https://www.gravatar.com/avatar/?d=mm"

        convertEmailToHash = (emailAddr) ->
          cleanEmailAddr = emailAddr.trim().toLowerCase()
          md5.createHash(cleanEmailAddr)

        view.generateGravatarQuery = (email) ->
          if email?
            emailHash = convertEmailToHash(email)
            urlParams = $httpParamSerializerJQLike
              s: view.IMAGE_SIZE_PX
              d: "mm"
            baseUrl = "https://www.gravatar.com/avatar/#{emailHash}?#{urlParams}"
          else
            view.DEFAULT_SRC

        @$onInit = ->
          view.IMAGE_SIZE_PX = view.size or= 152

        return view

    ]
    link: (scope) ->
      scope.$watch "view.email", () ->
        scope.view.src = scope.view.generateGravatarQuery(scope.view.email)


]
